import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";

class DaliEsSystemGroupForm extends Component {

    state = {
        form: {
            id: null,
            networkDeviceId: null,
            label: null,
            description: null,
            daliEsSystemGroupId: null,
            daliEsSystemAreaId: null
        },
        isEdit: false
    };

    componentDidMount() {
        if(!this.props.data) {
            this.setState({
                ...this.state,
                form: {
                    ...this.state.form,
                    networkDeviceId: parseInt(this.props.deviceId),
                    daliEsSystemAreaId: parseInt(this.props.areaId)
                }
            })
        }

        if((this.props.groupFromDevice !== null && this.props.groupFromDevice !== "error") && !this.props.data) {
            let index = 0;
            for (const [key, value] of Object.entries(this.props.groupFromDevice)) {
                if(index === 0) {
                    this.setState({
                        ...this.state,
                        form: {
                            ...this.state.form,
                            daliEsSystemGroupId: key,
                            label: value,
                            networkDeviceId: parseInt(this.props.deviceId),
                            daliEsSystemAreaId: parseInt(this.props.areaId)
                        }
                    })
                }
                index++;
            }
        }

        if(this.props.data) {
            const { data } = this.props;
            this.setState({
                ...this.state,
                isEdit: true,
                form: {
                    id: data.id,
                    networkDeviceId: data.networkDeviceId,
                    label: data.label,
                    description: data.description,
                    daliEsSystemGroupId: data.daliEsSystemGroupId,
                    daliEsSystemAreaId: data.daliEsSystemAreaId
                }
            });
        }
    }

    handleOnChangeInput = (e) => {
        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        });
    };

    handleSelect = (e) => {
        const { groupFromDevice } = this.props;
        e.preventDefault();
        const daliEsSystem = e.target.value;
        const daliEsSystemLabel = groupFromDevice[daliEsSystem];

        this.setState({
            ...this.state,
            form: {
                ...this.state.form,
                [e.target.name] : daliEsSystem,
                label: daliEsSystemLabel
            }
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();
        console.log(this.state.form);
        this.props.submitForm(this.state.form);
    };

    render() {
        const { t, groupFromDevice } = this.props;

        let index = 0;
        const selectItems = [];
        for (const [key, value] of Object.entries(groupFromDevice)) {
            selectItems.push( <option key={key} value={key} data-label={value}> [{key}]: {value} </option> );
            index++;
        }

        const groupInput = groupFromDevice !== null && groupFromDevice !== "error" && !this.state.isEdit ? (
            <select className="form-control" name="daliEsSystemGroupId" value={this.state.form.daliEsSystemGroupId || ''} onChange={this.handleSelect}>
                { selectItems?.map((item) => { return item } )};
            </select>
        ) : (
            <input
                className='form-control'
                name="daliEsSystemGroupId"
                title="daliEsSystemGroupId"
                value={this.state.form.daliEsSystemGroupId || ''}
                onChange={this.handleOnChangeInput}
                required
            />
        );

        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                        <label className="col-form-label">{t('group')}</label>
                        { groupInput }
                    </div>
                    <div className="form-group">
                        <label className="col-form-label">{t('label')}</label>
                        <input
                            className='form-control'
                            name="label"
                            title="label"
                            value={this.state.form.label || ''}
                            onChange={this.handleOnChangeInput}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label className="col-form-label">{t('description')}</label>
                        <textarea
                            className='form-control'
                            name="description"
                            title="description"
                            value={this.state.form.description || ''}
                            onChange={this.handleOnChangeInput}
                        />
                    </div>
                    <div className="form-group float-right">
                        { this.state.isEdit ? (
                            <button type="submit" className={"btn btn-primary" }>
                                <i className="fas fa-edit"> </i> {t('edit')}
                            </button>
                        ) : (
                            <button type="submit" className={"btn btn-success" }>
                                <i className="fas fa-plus"> </i> {t('create')}
                            </button>
                        ) }
                    </div>
                </form>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    const { groupFromDevice } = state.daliEsSystemReducer;
    return {
        groupFromDevice
    }
};
export default withNamespaces()(connect(mapStateToProps)(DaliEsSystemGroupForm));
